import {ModuleWithProviders, NgModule} from '@angular/core';
import {MatSliderModule} from '@angular/material/slider';
import {SliderComponent} from './components/slider/slider.component';
import {LevelToIntensityPipe} from '@core/pipes/level-to-intensity.pipe';
import {IntensityToLevelPipe} from '@core/pipes/intensity-to-level.pipe';
import {CommonModule} from '@angular/common';
import {CoreModule} from '@core/core.module';
import {ConversionsService} from '@shared/utils/conversions.service';
import {CardComponent} from './components/card/card.component';
import {MillisToMinutesPipe} from '@core/pipes/millis-to-minutes.pipe';
import {TranslateModule} from '@ngx-translate/core';
import {ButtonComponent} from './components/button/button.component';
import {MatIconModule} from '@angular/material/icon';
import {BackgroundComponent} from './components/background/background.component';
import {HeaderComponent} from '@shared/components/header/header.component';
import {TileComponent} from './components/tile/tile.component';
import {StatusLabelComponent} from './components/status-label/status-label.component';
import {WizardStepperComponent} from './components/wizard-stepper/wizard-stepper.component';
import {CommentComponent} from './components/comment/comment.component';
import {DropdownButtonComponent} from '@shared/components/dropdown-button/dropdown-button.component';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import {NotificationService} from '@shared/components/notification/service/notification.service';
import {NotificationComponent} from '@shared/components/notification/notification.component';
import {HttpClientModule} from '@angular/common/http';
import {PopupImageComponent} from '@shared/dialogs/unit-popup/popup-image/popup-image.component';
import {RadioButtonComponent} from './components/radio-button/radio-button.component';
import {MatRadioModule} from '@angular/material/radio';
import {ProgressBarComponent} from './components/progress-bar/progress-bar.component';
import {ProgressCircleGraphComponent} from './components/progress-circle-graph/progress-circle-graph.component';
import {LoaderComponent} from './components/loader/loader.component';
import {FileRestService} from '@core/modules/rest/file/file-rest.service';
import {TtsHelperService} from '@shared/utils/tts-helper.service';
import {A11yModule} from '@angular/cdk/a11y';
import {CheckboxComponent} from './components/checkbox/checkbox.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {SettingsService} from '@shared/utils/settings.service';
import {SlideToggleComponent} from './components/slide-toggle/slide-toggle.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {UnitPopupComponent} from '@shared/dialogs/unit-popup/unit-popup.component';
import {IvyCarouselModule} from 'angular-responsive-carousel';
import {SelectMenuComponent} from './components/select-menu/select-menu.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatOptionModule} from '@angular/material/core';
import {YesNoDialogComponent} from '@shared/dialogs/yes-no-dialog/yes-no-dialog.component';
import {UnitPopupWithPopupComponent} from './dialogs/unit-popup/unit-popup-with-popup/unit-popup-with-popup.component';
import {TextareaComponent} from './components/textarea/textarea.component';
import {MatInputModule} from '@angular/material/input';
import {PlayAudioService} from '@shared/utils/play-audio.service';
import {ImageCardComponent} from './components/image-card/image-card.component';
import {BlankDialogComponent} from './dialogs/blank-dialog/blank-dialog.component';
import {ListPopupComponent} from './dialogs/list-popup/list-popup.component';
import {PopupVideoComponent} from './dialogs/unit-popup/popup-video/popup-video.component';
import {VgBufferingModule, VgCoreModule, VgOverlayPlayModule} from 'ngx-videogular';
import {SelectMenuNoLabelComponent} from './components/select-menu/select-menu-no-label/select-menu-no-label.component';
import {AbstractDialogComponent} from '@shared/dialogs/abstract-dialog/abstract-dialog.component';
import {InfoPageComponent} from './components/info-page/info-page.component';
import {WizardHelperService} from '@shared/utils/wizard-helper.service';
import {MatTooltipModule} from '@angular/material/tooltip';

@NgModule({
    imports: [
        MatSliderModule,
        CommonModule,
        CoreModule,
        TranslateModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        HttpClientModule,
        MatRadioModule,
        A11yModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        FormsModule,
        IvyCarouselModule,
        MatFormFieldModule,
        MatSelectModule,
        MatOptionModule,
        MatInputModule,
        VgCoreModule,
        ReactiveFormsModule,
        VgOverlayPlayModule,
        VgBufferingModule,
        MatTooltipModule
    ],
    declarations: [
        SliderComponent,
        CardComponent,
        ButtonComponent,
        BackgroundComponent,
        HeaderComponent,
        TileComponent,
        StatusLabelComponent,
        WizardStepperComponent,
        UnitPopupComponent,
        YesNoDialogComponent,
        CommentComponent,
        DropdownButtonComponent,
        NotificationComponent,
        PopupImageComponent,
        RadioButtonComponent,
        LoaderComponent,
        ProgressBarComponent,
        ProgressCircleGraphComponent,
        CheckboxComponent,
        SlideToggleComponent,
        SelectMenuComponent,
        SelectMenuNoLabelComponent,
        TextareaComponent,
        UnitPopupWithPopupComponent,
        ImageCardComponent,
        BlankDialogComponent,
        ListPopupComponent,
        PopupVideoComponent,
        AbstractDialogComponent,
        InfoPageComponent
    ],
    exports: [
        SliderComponent,
        CardComponent,
        ButtonComponent,
        BackgroundComponent,
        HeaderComponent,
        TileComponent,
        WizardStepperComponent,
        CommentComponent,
        NotificationComponent,
        PopupImageComponent,
        RadioButtonComponent,
        StatusLabelComponent,
        LoaderComponent,
        ProgressBarComponent,
        ProgressCircleGraphComponent,
        CheckboxComponent,
        SlideToggleComponent,
        UnitPopupComponent,
        SelectMenuComponent,
        SelectMenuNoLabelComponent,
        UnitPopupComponent,
        YesNoDialogComponent,
        DropdownButtonComponent,
        TextareaComponent,
        PopupVideoComponent,
        ImageCardComponent,
        AbstractDialogComponent,
        MatTooltipModule
    ],
    providers: [
        FileRestService,
        LevelToIntensityPipe,
        IntensityToLevelPipe,
        MillisToMinutesPipe,
        ConversionsService,
        NotificationService,
        TtsHelperService,
        SettingsService,
        PlayAudioService,
        WizardHelperService
    ]
})

export class SharedModule {
    // This method is called only in AppModule
    // Its purpose is to create only one instance of given services
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: []
        };
    }
}
